import { createContext } from "react";

const ProvinceContext = createContext();

export default ProvinceContext;
